import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMenuPermissions } from '../hooks/useMenuPermissions';
import LoadingSpinner from './LoadingSpinner';

interface PermissionGuardProps {
  children: React.ReactNode;
  menuKey: string;
  requiredPermission?: 'access' | 'create' | 'edit' | 'delete' | 'view';
  fallbackPath?: string;
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  children,
  menuKey,
  requiredPermission = 'access',
  fallbackPath = '/dashboard'
}) => {
  // console.log('🔍 DEBUG: PermissionGuard renderizado', { menuKey, requiredPermission });
  
  const { canAccessMenu, canCreateInMenu, canEditInMenu, canDeleteInMenu, canViewInMenu, loading, permissions } = useMenuPermissions();
  
  // console.log('🔍 DEBUG: PermissionGuard state', { 
  // loading, 
  // menuKey, 
  // permissionsCount: permissions.length,
  // hasPermission: canAccessMenu(menuKey)
  // });

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  let hasPermission = false;

  switch (requiredPermission) {
    case 'access':
      hasPermission = canAccessMenu(menuKey);
      break;
    case 'create':
      hasPermission = canCreateInMenu(menuKey);
      break;
    case 'edit':
      hasPermission = canEditInMenu(menuKey);
      break;
    case 'delete':
      hasPermission = canDeleteInMenu(menuKey);
      break;
    case 'view':
      hasPermission = canViewInMenu(menuKey);
      break;
    default:
      hasPermission = canAccessMenu(menuKey);
  }

  if (!hasPermission) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default PermissionGuard;
